// src/utils/location.ts
interface LocationResponse {
  country: string;
  countryState: string;
}

export const getUserLocation = async (): Promise<LocationResponse> => {
  try {
    const ipResponse = await fetch("https://api.ipify.org?format=json");
    const { ip } = await ipResponse.json();
    const response = await fetch(`https://ip-api.com/json/${ip}`);
    const data = await response.json();

    // if (data.status === "fail") {
    //   throw new Error("Failed to get location");
    // }

    return {
      country: data.country || "Nigeria", // Fallback if country is not available
      countryState: data.city || "Abuja", // Fallback if region is not available
    };
  } catch (error) {
    console.error("Error fetching location:", error);
    // Return defaults if location fetch fails
    return {
      country: "Nigeria",
      countryState: "Abuja",
    };
  }
};
